import { useState, useEffect, useRef } from "react";
import SideMenu from "../../features/sideMenu/SideMenu";
import { itemsSoporte } from "../../constants/soporte";
import {
  getEquiposMedicion,
  descargarExcelEquiposMedicion,
  eliminarEquipoMedicion,
  createEquipoMedicion,
  updateEquipoMedicion,
} from "../functions/Soporte";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import Anadir from "../../assets/img/svg/anadir.svg";
import CustomButton from "../../ui/button/Button";
import Editar from "../../assets/img/svg/users/editar_blanco.svg";
import EditarA from "../../assets/img/svg/users/editar.svg";
import Eliminar from "../../assets/img/svg/users/eliminar.svg";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Button,
  Menu,
  MenuItem,
  Snackbar,
  ClickAwayListener,
  Popper,
} from "@mui/material";
import DescargarG from "../../assets/img/svg/users/descargarGreen.svg";
import SubirG from "../../assets/img/svg/providers/CargarVerde.svg";
import LoaderDialog from "../../ui/loader/Loader";
import { headCellCenterAlign } from "../../utils/columnStyles";
import Ajustes from "../../assets/img/svg/users/opciones.svg";
import useConfirmDialog from "../../features/modal/ConfirmDialog";
import NuevoEquipoMedicionModal from "./modals/NuevoEquipoMedicionModal";
import CalcularEquipoMedicion from "./modals/CalcularEquipoMedicion";

const SeleccionDeTransformadores = ({ API_URL, user }) => {
  const showDialog = useConfirmDialog();

  const [tableInstance, setTableInstance] = useState(null);
  const [data, setData] = useState([]);
  const [showModalSubirArchivo, setShowModalSubirArchivo] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [openMenuIndex, setOpenMenuIndex] = useState(null);

  const [showNuevoEquipoMedicionModal, setShowNuevoEquipoMedicionModal] =
    useState(false);

  const [showModalCalcularEquipoMedicion, setShowModalCalcularEquipoMedicion] =
    useState(false);

  const [selectedEquipo, setSelectedEquipo] = useState(null);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setShowLoader(true);
        const equipos = await getEquiposMedicion(API_URL);
        setData(equipos);
      } catch (error) {
      } finally {
        setShowLoader(false);
      }
    };
    fetchData();
  }, []);

  const columns = [
    {
      accessorKey: "id",
      header: "ID",
    },
    {
      accessorKey: "tipoTensionEquipo.descripcion",
      header: "Nivel de tensión",
    },
    {
      accessorKey: "tipoEquipo.lenguaje",
      header: "Tipo de equipo",
      accessorFn: (row) => {
        const value = row?.tipoEquipo?.lenguaje;
        switch (value) {
          case "AERIAL":
            return "Aéreo";
          case "UNDERGOUND_PEDESTAL":
            return "Subterráneo (Pedestal)";
          case "NOT_APPLICABLE":
            return "No aplica";
          default:
            return value;
        }
      },
    },
    {
      accessorKey: "voltaje",
      header: "Voltaje",
      accessorFn: (row) => {
        const value = row?.voltaje;
        return `${value || 0} V`;
      },
    },
    {
      accessorKey: "corrienteMin",
      header: "Corriente mínima",
      accessorFn: (row) => {
        const value = row?.corrienteMin;
        return `${value || 0} A`;
      },
    },
    {
      accessorKey: "corrienteMax",
      header: "Corriente máxima",
      accessorFn: (row) => {
        const value = row?.corrienteMax;
        return `${value || 0} A`;
      },
    },
    {
      accessorKey: "relacionTransformacionCorriente",
      header: "REL TC",
    },
    {
      accessorKey: "equipo",
      header: "Equipo",
    },
    {
      id: "submenu",
      header: " ",
      size: 50,
      muiTableHeadCellProps: {
        sx: headCellCenterAlign,
      },
      Cell: ({ row }) => {
        const rowData = row.original;
        const anchorRef = useRef(null);
        const isOpen = openMenuIndex === row.index;

        return (
          <div
            style={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <button
              ref={anchorRef}
              onClick={() =>
                setOpenMenuIndex((prevIndex) =>
                  prevIndex === row.index ? null : row.index
                )
              }
              className="action-icon"
            >
              <img
                src={Ajustes}
                alt="Ajustes"
                style={{ width: "20px", height: "20px" }}
              />
            </button>
            <Popper
              open={isOpen}
              anchorEl={anchorRef.current}
              placement="bottom-start"
              style={{ zIndex: 9999 }}
            >
              <ClickAwayListener onClickAway={() => setOpenMenuIndex(null)}>
                <div
                  className="dropdown-menu-user"
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    marginTop: "5px",
                    padding: "5px",
                    minWidth: "80px",
                  }}
                >
                  <p
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 10px",
                    }}
                    onClick={() => {
                      setOpenMenuIndex(null);
                      setSelectedEquipo(rowData);
                      setShowNuevoEquipoMedicionModal(true);
                    }}
                  >
                    <img
                      src={EditarA}
                      alt=""
                      style={{
                        width: "16px",
                        height: "16px",
                        marginRight: "8px",
                      }}
                    />
                    Editar
                  </p>
                  <p
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 10px",
                    }}
                    onClick={() => {
                      showDialog({
                        icon: "warning",
                        html: "¿Estas seguro de eliminar el equipo de medición?",
                        confirmButtonText: "Eliminar",
                        mostrarCancelar: true,
                        onConfirm: async () => {
                          try {
                            setShowLoader(true);
                            await eliminarEquipoMedicion(API_URL, rowData.id);
                            setData((prevData) =>
                              prevData.filter((item) => item.id !== rowData.id)
                            );
                            setShowSnackbar(true);
                            setSnackbarMessage(
                              "Equipo de medición eliminado correctamente."
                            );
                          } catch (error) {
                            setShowSnackbar(true);
                            setSnackbarMessage(
                              "Error eliminando el equipo de medición."
                            );
                          } finally {
                            setShowLoader(false);
                          }
                        },
                      });
                    }}
                  >
                    <img
                      src={Eliminar}
                      alt=""
                      style={{
                        width: "16px",
                        height: "16px",
                        marginRight: "8px",
                      }}
                    />
                    Eliminar
                  </p>
                </div>
              </ClickAwayListener>
            </Popper>
          </div>
        );
      },
    },
  ];

  const table = useMaterialReactTable({
    columns,
    data,
    enableSorting: true,
    enableFilters: false,
    enableTopToolbar: false,
    enableColumnActions: false,
    getRowId: (originalRow) => originalRow.id,
    positionToolbarAlertBanner: "none",
    localization: MRT_Localization_ES,
    defaultColumn: {
      minSize: 40,
      size: 80,
    },
  });

  const handleNuevoEquipoMedicion = async (data) => {
    setShowLoader(true);
    try {
      if (selectedEquipo) {
        await updateEquipoMedicion(API_URL, data);
      } else {
        await createEquipoMedicion(API_URL, data);
      }
      const equipos = await getEquiposMedicion(API_URL);
      setData(equipos);
      setShowSnackbar(true);
      setSnackbarMessage("Equipo de medición guardado correctamente.");
    } catch (error) {
      setShowSnackbar(true);
      setSnackbarMessage("Error al guardar el equipo de medición.");
    } finally {
      setShowLoader(false);
      setSelectedEquipo(null);
    }
  };

  return (
    <div className="mi-container" style={{ display: "flex", width: "100%" }}>
      <div className="mi-sidebar" style={{ width: "12rem" }}>
        <SideMenu items={itemsSoporte} />
      </div>
      <LoaderDialog open={showLoader} />

      <NuevoEquipoMedicionModal
        open={showNuevoEquipoMedicionModal}
        onClose={() => {
          setShowNuevoEquipoMedicionModal(false);
          setSelectedEquipo(null);
        }}
        API_URL={API_URL}
        onConfirm={(newEquipo) => {
          setShowNuevoEquipoMedicionModal(false);
          handleNuevoEquipoMedicion(newEquipo);
        }}
        equipo={selectedEquipo}
      />

      <CalcularEquipoMedicion
        open={showModalCalcularEquipoMedicion}
        onClose={() => setShowModalCalcularEquipoMedicion(false)}
        API_URL={API_URL}
      />

      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => {
          setShowSnackbar(false);
          setSnackbarMessage("");
        }}
        message={snackbarMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        slotProps={{
          content: {
            sx: {
              backgroundColor: "white",
              color: "#222",
              justifyContent: "center",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "16px",
              fontFamily: "Roboto, Arial, sans-serif",
            },
          },
        }}
      />

      {/* Contenido principal */}
      <div
        className="mi-main"
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          padding: "10px",
        }}
      >
        <div
          className="pgp-controls"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            marginBottom: "16px",
          }}
        >
          <h1 className="map-title" style={{ margin: 0 }}>
            Selección de Transformadores
          </h1>
          {user?.perfil?.esAdministrador && (
            <CustomButton
              background="#223D51"
              width="220px"
              height="31px"
              fontSize="14px"
              color="#FFFFFF"
              text="Agregar equipo de medición"
              fontWeight={700}
              fontStyle="normal"
              border={0}
              icon={true}
              src={Anadir}
              iconW="12px"
              iconM="5px"
              onClick={() => {
                setSelectedEquipo(null);
                setShowNuevoEquipoMedicionModal(true);
              }}
            />
          )}
          <CustomButton
            background="#223D51"
            width="220px"
            height="31px"
            fontSize="14px"
            color="#FFFFFF"
            text="Calcular equipo de medición"
            fontWeight={700}
            fontStyle="normal"
            border={0}
            icon={true}
            src={Editar}
            iconW="12px"
            iconM="5px"
            onClick={() => {
              setShowModalCalcularEquipoMedicion(true);
            }}
          />
          <Button
            onClick={handleClick}
            className="custom-button-menu-cc"
            endIcon={<KeyboardArrowDownIcon />}
          >
            Subir y Descargar
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            slotProps={{
              list: {
                "aria-labelledby": "basic-button",
              },
            }}
          >
            <MenuItem className="menu-item-text" onClick={() => {}}>
              <img
                src={SubirG}
                alt=""
                style={{ width: "16px", marginRight: "8px" }}
              />
              Subir Excel para editar
            </MenuItem>
            <MenuItem
              className="menu-item-text"
              onClick={async () => {
                handleClose();
                try {
                  setShowLoader(true);
                  const blob = await descargarExcelEquiposMedicion(
                    API_URL,
                    data
                  );
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.href = url;
                  a.download = `Equipos_de_medicion.xls`;
                  a.rel = "noopener";
                  document.body.appendChild(a);
                  a.click();
                  a.remove();
                  setTimeout(() => URL.revokeObjectURL(url), 1000);
                } catch (error) {
                } finally {
                  setShowLoader(false);
                }
              }}
            >
              <img
                src={DescargarG}
                alt=""
                style={{ width: "16px", marginRight: "8px" }}
              />
              Descargar Excel
            </MenuItem>
          </Menu>
        </div>

        <div>
          <MaterialReactTable
            table={table}
            onTableReady={(table) => setTableInstance(table)}
          />
        </div>
      </div>
    </div>
  );
};

export default SeleccionDeTransformadores;
